import rsyncRegion from '@/api/common/rsyncRegion'
rsyncRegion()

const regions = window.yioksRegion ? window.yioksRegion.regions : []

export default regions
